var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[(!_vm.show)?_c('Start',{on:{"back":_vm.onBack}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }